var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-wrapper"},[_c('div',{attrs:{"id":"kr-wrapper"},on:{"click":_vm.getMousePosition}}),(_vm.showDesign)?_c('KrDesign',{attrs:{"selectHotSpot":_vm.selectHotSpot,"selectRadar":_vm.selectRadar}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }